const ApplicationError = () => {
    return (
        <h1>Application Error</h1>
    )
}

export default ApplicationError;